import { Button, Card, CardContent, CardHeader, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Pagination, Paper, Select, SelectChangeEvent, Stack, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { useCallback, useEffect, useState,KeyboardEvent } from "react";
import { useNavigate } from "react-router-dom";
import { T_Inquery } from "../../common/model/InqueryModel";
import { useProgress } from "../../contexts/ProgressContextProvider";
import { T_Page } from "../../common/model/apiModel";
import apis from "../../common/apis";
import { T_Trouble } from "../../common/model/troubleModel";
import React from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert"
import { initialAlert, useAlert } from "../../provider/AlertContextProvider";
import AttachFileIcon from '@mui/icons-material/AttachFile';  
import { T_File } from "../../common/model/fileModel";
import values from "../../common/values";
import { T_Code } from "../../common/model/codeModel";
import { Search, SearchIconWrapper, StyledInputBase, StyledTableCell } from '../../common/style/styles';
import SearchIcon from '@mui/icons-material/Search';
import { T_Board } from "../../common/model/boardModel";
      


export default function TestBoardList(){

    const nav = useNavigate();

    const pagesize = 10;
    const [page,setPage] = useState(1);
    const [list,setList] =  useState<T_Board[] | null>(null);
    const {showProgress,setShowProgress} = useProgress();
    const [pageInfo,setPageInfo] = useState<T_Page>()
    const {alert,setAlert} = useAlert();
    const [skeyword,setSkeyword]=useState("");
    
        
    const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
      };

    const handleDataDel = async(item:T_Board)=>{

        setAlert({...alert,visible:true,msg:"정말로 삭제 하시겠습니까?",buttonList:[{text:"예",variant:"contained",onPress:async()=>{
            console.log("del request:",item)
                const result = await apis.board.boardDelete(item);
                console.log("del result:",result)
                if(result.code=="1"){
                    setAlert(initialAlert);
                    setAlert({...alert,msg:"정상적으로 삭제되었습니다."})
                   getList();
                }else{
                    setAlert(initialAlert);
                    setAlert({...alert,msg:"삭제중 오류가 발생하였습니다다."})
                }
                
        }}
        ,{text:"아니요",variant:"outlined",onPress:()=>{
            setAlert({...alert,visible:false});

        }}
    ]})
    }  

  
 // 파일 메뉴 상태
  const [anchorElFile, setAnchorElFile] = useState<null | HTMLElement>(null);
  const [fileMenuRow, setFileMenuRow] = useState<number | null>(null);
  const handleFileIconClick = (e: React.MouseEvent<HTMLElement>, row: number) => {
    setAnchorElFile(e.currentTarget);
    setFileMenuRow(row);
  };
  const handleFileMenuClose = () => {
    setAnchorElFile(null);
    setFileMenuRow(null);
  };

  // 파일 다운로드
  // const handleDownload = (file: T_File) => {
  //   const link = document.createElement('a');
  //   link.href = values.server.url+"/upload/"+ file.fileUrl;
  //  file.fileOrgNm &&  link.setAttribute('download', file.fileOrgNm);
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  //   handleFileMenuClose();
  // };


        // 파일 다운로드
  const handleDownload = async (file: T_File) => {

      try {
        const url = `${values.server.url}/upload/${file.fileUrl??""}`;


        // 인증이 필요하면 credentials 옵션 추가
        const res = await fetch(url, { credentials: 'include' });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);

        const blob = await res.blob();
        const blobUrl = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = file.fileOrgNm || 'download'; // 저장 파일명
        document.body.appendChild(a);
        a.click();
        a.remove();

        window.URL.revokeObjectURL(blobUrl);
      } catch (e) {
        setAlert({ ...initialAlert, visible: true, msg: '다운로드 중 오류가 발생했습니다.' });
        console.error(e);
  }

  };


   const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [menuRow, setMenuRow] = useState<number | null>(null)
    const open = Boolean(anchorEl);
    const handleClick = (e: React.MouseEvent<HTMLElement>, idx: number) => {
      setAnchorEl(e.currentTarget)
      setMenuRow(idx)
    }   
    const handleClose = () => {
        setAnchorEl(null);
        setMenuRow(null);
      }; 

      const handleRowClick = (item:T_Board) => {
           nav("/testboard/view",{state:{item:item}})  
      }; 


    const getList = useCallback(async () => {
        try {
          setShowProgress(true);
          const result = await apis.board.boardList(
            {
              page:Number(page),
              pagesize:pagesize,
              type:"testboard",
              skeyword:skeyword
            }
          );
          console.log("resut:",result)
            if(result.code=="1"){
            
                setList(result.data.list);
                setPageInfo(result.data);
                setShowProgress(false);
    
            }else{
                 
              setShowProgress(false);
            }
    
       
    
        } catch (err: any) {
          setShowProgress(false);
        }
      }, [page,skeyword]);

 
   function onKeyDown(e: KeyboardEvent<HTMLTextAreaElement | HTMLInputElement>) {
      if (e.key === 'Enter') {
        e.preventDefault(); // form 리프레시 방지
          getList()
      }
    }

      useEffect(() => {
          getList();
      }, [page]);   


    return(
      <>
      <Card sx={{width:'100%'}} >
        <CardHeader sx={{pr:5,pb:0,mb:0}} title="테스트 현황"  action={
          <Stack   direction="row"
                justifyContent="space-between"  // ← 여기만 바꿔주세요
                spacing={2}                     // 아이템 사이 약간의 간격
                sx={{ pt: 5, width: '100%' }}   // 전체 너비 확보
                >
                  <Search>
                      <SearchIconWrapper onClick={() => setPage(1)}>
                        <SearchIcon />
                      </SearchIconWrapper>
                      <StyledInputBase
                        placeholder="Search…"
                        inputProps={{ 'aria-label': 'search' }}
                        value={skeyword}
                        onChange={(e) => {
                          setSkeyword(e.target.value);
                        }
                      }
                        onKeyDown={onKeyDown}
                      />
                    </Search>   

          <Button variant="outlined" onClick={()=>{
            nav("/testboard/insert")
          }}>
           등록
          </Button>
          </Stack>
        }
        />
        <CardContent>
        <TableContainer component={Paper}>
      <Table  aria-label="simple table">
        <TableHead>
          <TableRow>
            <StyledTableCell  sx={{width:'25%',textAlign:'center'}}>제목</StyledTableCell>
            <StyledTableCell align="left" sx={{textAlign:'center'}} >내용</StyledTableCell>
            <StyledTableCell align="center"  sx={{width:100,textAlign:'center'}}>첨부파일</StyledTableCell>
            <StyledTableCell align="center"  sx={{width:100,textAlign:'center'}}>작성자</StyledTableCell>
            <StyledTableCell align="center"  sx={{width:100,textAlign:'center'}}>비고</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
        {list && list.map((item,idx) => (
            <TableRow
              key={idx}
              sx={{ '&:last-child td, &:last-child th': { border: 0 },cursor:'pointer'} }
                onClick={() => handleRowClick(item)}
              hover
              >
              <TableCell component="th" scope="row">
                {item.title}
              </TableCell>
              <TableCell align="left">  { item.contents && item.contents.length > 50
                                        ? `${item.contents.slice(0, 50)}...`
                                        : item.contents}
              </TableCell>
             {/* 파일 셀 */}
                  <TableCell align="center">
                    {item.files && item.files.length > 0 ? (
                      <>
                        <IconButton
                          size="small"
                          onClick={(e) =>
                            {  
                                e.stopPropagation();   
                            handleFileIconClick(e, idx)
                            }
                          
                          }
                        >
                          <AttachFileIcon />
                        </IconButton>
                        <Menu
                          anchorEl={anchorElFile}
                          open={fileMenuRow === idx}
                           onClose={(event, reason)=>{
                                    (event as any)?.stopPropagation?.();   // ✅ 안전하게 전파 차단
                                      handleFileMenuClose();
                                  }
                                 }
                          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                          transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                        >
                          {item.files.map((file, idx2) => (
                            <MenuItem key={idx2} onClick={(e) =>{ 
                              e.stopPropagation();   
                              handleDownload(file)
                            }}>
                              <ListItemIcon>
                                <AttachFileIcon fontSize="small" />
                              </ListItemIcon>
                              <ListItemText>{file.fileOrgNm}</ListItemText>
                            </MenuItem>
                          ))}
                        </Menu>
                      </>
                    ) : (
                      '—'
                    )}
                  </TableCell>
              <TableCell component="th" scope="row" align="center">
                {item.userinfo?.userNm}
              </TableCell>                  
              <TableCell align="center">{ <>
                    <IconButton
                      aria-label="menu"
                      onClick={(e) => 
                      {
                           e.stopPropagation();   
                        handleClick(e, idx)
                      }
                      }
                    >
                      <MoreVertIcon />
                    </IconButton>
                    <Menu
                      anchorEl={anchorEl}
                      open={menuRow === idx}
                      onClose={(event, reason)=>{
                         (event as any)?.stopPropagation?.();   // ✅ 안전하게 전파 차단
                           handleClose();
                      }
                        }
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                    >
                      <MenuItem
                        onClick={(e) => {
                             e.stopPropagation();   
                          handleClose()
                          nav("/testboard/edit",{state:{item:item}})  
                        }}
                      >
                        수정
                      </MenuItem>
                      <MenuItem
                        onClick={async(e) => {
                           e.stopPropagation();   
                          handleClose()
                          handleDataDel(item)
                        }}
                      >
                        삭제
                      </MenuItem>
                    </Menu>
                  </>}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
        <Stack   direction="row"
        justifyContent="flex-end"
        alignItems="center" sx={{pt:5,justifyContent:'center',alignContent:'center',justifyItems:'center',alignItems:'ceter'}}>
        <Pagination count={pageInfo?.pages} showFirstButton showLastButton boundaryCount={2} onChange={handleChange}/>
        </Stack>
        </CardContent>
      </Card>
      </>
    )
}